const AuditorSideMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'auditor.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-home-4-line'
  },
  {
    title: 'Payment Requests',
    is_heading: false,
    is_active: false,
    link: {
      name: 'auditor.payment-requests'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-currency-line'
  }
]

export default AuditorSideMenu
